module.exports = __webpack_public_path__ + "static/hyeon-c9bd4204bceafe1886bd3ab00a50dd89.jpg";